import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Calendar, TrendingUp } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';
import { actifsMatches, actifsStandings } from '../data/interclubs';

const isCheyres = (name) => name && name.includes('Cheyres');

const InterclubsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />

      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Interclubs Actifs
            </h1>
            <p className="text-xl text-gray-600">
              Championnat interclubs Swiss Tennis - Saison 2026 - 35+ 3L Messieurs
            </p>
          </div>

          {/* Notre équipe */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-3xl mb-12">
            <div className="flex items-center mb-6">
              <Trophy className="w-12 h-12 text-green-600 mr-4" />
              <h2 className="text-3xl font-bold text-gray-900">Notre équipe 2026</h2>
            </div>
            <p className="text-gray-700 text-lg mb-6">Le TC Cheyres-Châbles compte 1 équipe engagée en championnat interclubs :</p>
            <div className="max-w-md">
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Équipe 35+ Messieurs</h3>
                <p className="text-blue-600 font-semibold">3ème Ligue - Groupe 22</p>
              </div>
            </div>
          </div>

          {/* Programme 2026 */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Équipe 35+ Messieurs - 3L Groupe 22</h2>

            {/* Résultats */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <Calendar className="w-6 h-6 text-blue-600 mr-2" />
                Résultats
              </h3>
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
                    <tr>
                      <th className="px-4 py-3 text-center">Tour</th>
                      <th className="px-4 py-3 text-center">Date</th>
                      <th className="px-4 py-3 text-left">Rencontre</th>
                      <th className="px-4 py-3 text-center">Score</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {actifsMatches.map((m, idx) => {
                      const hasCheyres = isCheyres(m.home) || isCheyres(m.away);
                      return (
                        <tr
                          key={idx}
                          className={
                            hasCheyres
                              ? 'bg-yellow-50 hover:bg-yellow-100 border-l-4 border-yellow-500'
                              : 'hover:bg-gray-50'
                          }
                        >
                          <td className="px-4 py-3 text-center font-semibold">{m.tour}</td>
                          <td className="px-4 py-3 text-center">{m.date}</td>
                          <td className={`px-4 py-3 ${hasCheyres ? 'font-bold text-green-700' : ''}`}>
                            {m.home} - {m.away}
                          </td>
                          <td className="px-4 py-3 text-center font-semibold">{m.score}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Classement */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <TrendingUp className="w-6 h-6 text-green-600 mr-2" />
                Classement
              </h3>
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gradient-to-r from-green-600 to-emerald-600 text-white">
                    <tr>
                      <th className="px-4 py-3 text-center">Rang</th>
                      <th className="px-4 py-3 text-left">Équipe</th>
                      <th className="px-4 py-3 text-center">PT</th>
                      <th className="px-4 py-3 text-center">SET</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {actifsStandings.map((row) => (
                      <tr
                        key={row.rank}
                        className={
                          isCheyres(row.team)
                            ? 'bg-yellow-50 hover:bg-yellow-100 border-l-4 border-yellow-500'
                            : 'hover:bg-gray-50'
                        }
                      >
                        <td className="px-4 py-3 font-bold text-center">{row.rank}</td>
                        <td className={`px-4 py-3 ${isCheyres(row.team) ? 'font-semibold text-green-700' : ''}`}>
                          {row.team}
                        </td>
                        <td className={`px-4 py-3 text-center ${isCheyres(row.team) ? 'font-semibold' : ''}`}>{row.pts}</td>
                        <td className={`px-4 py-3 text-center ${isCheyres(row.team) ? 'font-semibold' : ''}`}>{row.sets}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />

      <Footer />
    </div>
  );
};

export default InterclubsPage;
